/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddHotelMappingRequest } from '../model';
// @ts-ignore
import { AutoCompleteHotelResponse } from '../model';
// @ts-ignore
import { CreateHotelRequest } from '../model';
// @ts-ignore
import { CreateHotelResponse } from '../model';
// @ts-ignore
import { EditHotelMessageRequest } from '../model';
// @ts-ignore
import { GetHotelMappingListResponse } from '../model';
// @ts-ignore
import { HotelCalendarDto } from '../model';
// @ts-ignore
import { HotelCityFullDetailView } from '../model';
// @ts-ignore
import { HotelDto } from '../model';
// @ts-ignore
import { HotelFullDetailView } from '../model';
// @ts-ignore
import { HotelFullDetailsResponse } from '../model';
// @ts-ignore
import { HotelRecommendationDto } from '../model';
// @ts-ignore
import { HotelResponse } from '../model';
// @ts-ignore
import { HotelSearchResponse } from '../model';
// @ts-ignore
import { HotelShortDetailResponse } from '../model';
// @ts-ignore
import { HotelTypeListResponse } from '../model';
// @ts-ignore
import { OrphanHotelMappingsResponse } from '../model';
// @ts-ignore
import { RoomsResponse } from '../model';
// @ts-ignore
import { UpdateHotelImageRequest } from '../model';
// @ts-ignore
import { UpdateHotelMappingRequest } from '../model';
// @ts-ignore
import { UpdateHotelRequest } from '../model';
/**
 * HotelApiApiHotelBackgroundHotelUpdatePost - axios parameter creator
 * 
 * @param {number} [hotelId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelBackgroundHotelUpdatePostAxiosParamCreator (hotelId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/BackgroundHotelUpdate`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (hotelId !== undefined) {
        localVarQueryParameter['hotelId'] = hotelId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameGetAllHotelRoomGet - axios parameter creator
 * 
 * @param {string} cityName 
 * @param {string} [hotelName] 
 * @param {number} [pageIndex] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameGetAllHotelRoomGetAxiosParamCreator (cityName: string, hotelName?: string, pageIndex?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelCityNameGetAllHotelRoomGet', 'cityName', cityName)
    const localVarPath = `/api/hotel/{cityName}/GetAllHotelRoom`
        .replace(`{${"cityName"}}`, encodeURIComponent(String(cityName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (hotelName !== undefined) {
        localVarQueryParameter['hotelName'] = hotelName;
    }

    if (pageIndex !== undefined) {
        localVarQueryParameter['pageIndex'] = pageIndex;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameCalendarGet - axios parameter creator
 * 
 * @param {string} cityName 
 * @param {string} hotelName 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameCalendarGetAxiosParamCreator (cityName: string, hotelName: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameCalendarGet', 'cityName', cityName)
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameCalendarGet', 'hotelName', hotelName)
    const localVarPath = `/api/hotel/{cityName}/{hotelName}/calendar`
        .replace(`{${"cityName"}}`, encodeURIComponent(String(cityName)))
        .replace(`{${"hotelName"}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameGet - axios parameter creator
 * 
 * @param {string} cityName 
 * @param {string} hotelName 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {number} [adultCount] 
 * @param {number} [childrenCount] 
 * @param {number} [roomCount] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameGetAxiosParamCreator (cityName: string, hotelName: string, from?: string, to?: string, adultCount?: number, childrenCount?: number, roomCount?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameGet', 'cityName', cityName)
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameGet', 'hotelName', hotelName)
    const localVarPath = `/api/hotel/{cityName}/{hotelName}`
        .replace(`{${"cityName"}}`, encodeURIComponent(String(cityName)))
        .replace(`{${"hotelName"}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameRecommendationsGet - axios parameter creator
 * 
 * @param {string} cityName 
 * @param {string} hotelName 
 * @param {string} [checkIn] 
 * @param {string} [checkOut] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameRecommendationsGetAxiosParamCreator (cityName: string, hotelName: string, checkIn?: string, checkOut?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameRecommendationsGet', 'cityName', cityName)
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameRecommendationsGet', 'hotelName', hotelName)
    const localVarPath = `/api/hotel/{cityName}/{hotelName}/recommendations`
        .replace(`{${"cityName"}}`, encodeURIComponent(String(cityName)))
        .replace(`{${"hotelName"}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (checkIn !== undefined) {
        localVarQueryParameter['checkIn'] = (checkIn as any instanceof Date) ?
            (checkIn as any).toISOString() :
            checkIn;
    }

    if (checkOut !== undefined) {
        localVarQueryParameter['checkOut'] = (checkOut as any instanceof Date) ?
            (checkOut as any).toISOString() :
            checkOut;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameRoomsGet - axios parameter creator
 * 
 * @param {string} cityName 
 * @param {string} hotelName 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {number} [adultCount] 
 * @param {number} [childrenCount] 
 * @param {number} [roomCount] 
 * @param {string} [xPlayerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameRoomsGetAxiosParamCreator (cityName: string, hotelName: string, from?: string, to?: string, adultCount?: number, childrenCount?: number, roomCount?: number, xPlayerId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameRoomsGet', 'cityName', cityName)
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameRoomsGet', 'hotelName', hotelName)
    const localVarPath = `/api/hotel/{cityName}/{hotelName}/rooms`
        .replace(`{${"cityName"}}`, encodeURIComponent(String(cityName)))
        .replace(`{${"hotelName"}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameStaticGet - axios parameter creator
 * 
 * @param {string} cityName 
 * @param {string} hotelName 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameStaticGetAxiosParamCreator (cityName: string, hotelName: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameStaticGet', 'cityName', cityName)
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameStaticGet', 'hotelName', hotelName)
    const localVarPath = `/api/hotel/{cityName}/{hotelName}/static`
        .replace(`{${"cityName"}}`, encodeURIComponent(String(cityName)))
        .replace(`{${"hotelName"}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityTagGet - axios parameter creator
 * 
 * @param {string} cityTag 
 * @param {string} [xPlayerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityTagGetAxiosParamCreator (cityTag: string, xPlayerId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityTag' is not null or undefined
    assertParamExists('apiHotelCityTagGet', 'cityTag', cityTag)
    const localVarPath = `/api/hotel/{cityTag}`
        .replace(`{${"cityTag"}}`, encodeURIComponent(String(cityTag)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCreateHotelMappingHotelIdPost - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {AddHotelMappingRequest} [addHotelMappingRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCreateHotelMappingHotelIdPostAxiosParamCreator (hotelId: number, addHotelMappingRequest?: AddHotelMappingRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelCreateHotelMappingHotelIdPost', 'hotelId', hotelId)
    const localVarPath = `/api/hotel/CreateHotelMapping/{hotelId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addHotelMappingRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {number} hotelMappingId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteAxiosParamCreator (hotelId: number, hotelMappingId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete', 'hotelId', hotelId)
    // verify required parameter 'hotelMappingId' is not null or undefined
    assertParamExists('apiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete', 'hotelMappingId', hotelMappingId)
    const localVarPath = `/api/hotel/DeleteHotelMapping/{hotelId}/{hotelMappingId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)))
        .replace(`{${"hotelMappingId"}}`, encodeURIComponent(String(hotelMappingId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelGetAllHotelsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelGetAllHotelsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/GetAllHotels`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelGetHotelsWithRoomsCityIdGet - axios parameter creator
 * 
 * @param {number} cityId 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {boolean} [isOnlyDb] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelGetHotelsWithRoomsCityIdGetAxiosParamCreator (cityId: number, from?: string, to?: string, isOnlyDb?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityId' is not null or undefined
    assertParamExists('apiHotelGetHotelsWithRoomsCityIdGet', 'cityId', cityId)
    const localVarPath = `/api/hotel/GetHotelsWithRooms/{cityId}`
        .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (isOnlyDb !== undefined) {
        localVarQueryParameter['isOnlyDb'] = isOnlyDb;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelAutoCompleteListGet - axios parameter creator
 * 
 * @summary Get Hotel AutoComplete List
 * @param {string} [searchTerm] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelAutoCompleteListGetAxiosParamCreator (searchTerm?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelAutoCompleteList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (searchTerm !== undefined) {
        localVarQueryParameter['searchTerm'] = searchTerm;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet - axios parameter creator
 * 
 * @param {string} cityName 
 * @param {string} hotelName 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetAxiosParamCreator (cityName: string, hotelName: string, from?: string, to?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelHotelAvailabilityCityNameHotelNameGet', 'cityName', cityName)
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists('apiHotelHotelAvailabilityCityNameHotelNameGet', 'hotelName', hotelName)
    const localVarPath = `/api/hotel/HotelAvailability/{cityName}/{hotelName}`
        .replace(`{${"cityName"}}`, encodeURIComponent(String(cityName)))
        .replace(`{${"hotelName"}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelFullDetailsHotelIdGet - axios parameter creator
 * 
 * @summary Get Hotel Full Details
 * @param {number} hotelId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelFullDetailsHotelIdGetAxiosParamCreator (hotelId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelFullDetailsHotelIdGet', 'hotelId', hotelId)
    const localVarPath = `/api/hotel/HotelFullDetails/{hotelId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdAssignMappingMappingIdPost - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {number} mappingId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdAssignMappingMappingIdPostAxiosParamCreator (hotelId: number, mappingId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdAssignMappingMappingIdPost', 'hotelId', hotelId)
    // verify required parameter 'mappingId' is not null or undefined
    assertParamExists('apiHotelHotelIdAssignMappingMappingIdPost', 'mappingId', mappingId)
    const localVarPath = `/api/hotel/{hotelId}/assign-mapping/{mappingId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)))
        .replace(`{${"mappingId"}}`, encodeURIComponent(String(mappingId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdGet - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {number} [adultCount] 
 * @param {number} [childrenCount] 
 * @param {number} [roomCount] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdGetAxiosParamCreator (hotelId: number, from?: string, to?: string, adultCount?: number, childrenCount?: number, roomCount?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdGet', 'hotelId', hotelId)
    const localVarPath = `/api/hotel/{hotelId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdStaticGet - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdStaticGetAxiosParamCreator (hotelId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdStaticGet', 'hotelId', hotelId)
    const localVarPath = `/api/hotel/{hotelId}/static`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelMappingListHotelIdGet - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelMappingListHotelIdGetAxiosParamCreator (hotelId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelMappingListHotelIdGet', 'hotelId', hotelId)
    const localVarPath = `/api/hotel/HotelMappingList/{hotelId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelTypeListGet - axios parameter creator
 * 
 * @summary Get Hotel Type List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelTypeListGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelTypeList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet - axios parameter creator
 * 
 * @param {string} cityCode 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetAxiosParamCreator (cityCode: string, from?: string, to?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'cityCode' is not null or undefined
    assertParamExists('apiHotelHotelsAvailabilityByCityCityCodeGet', 'cityCode', cityCode)
    const localVarPath = `/api/hotel/HotelsAvailabilityByCity/{cityCode}`
        .replace(`{${"cityCode"}}`, encodeURIComponent(String(cityCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelsWithMessageGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelsWithMessageGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelsWithMessage`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelMessagePost - axios parameter creator
 * 
 * @summary update message of hotel
 * @param {EditHotelMessageRequest} [editHotelMessageRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelMessagePostAxiosParamCreator (editHotelMessageRequest?: EditHotelMessageRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/Message`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(editHotelMessageRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelOrphanHotelMappingsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelOrphanHotelMappingsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/orphan-hotel-mappings`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelPost - axios parameter creator
 * 
 * @param {CreateHotelRequest} [createHotelRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelPostAxiosParamCreator (createHotelRequest?: CreateHotelRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createHotelRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelRemoveHotelPageCacheHotelIdDelete - axios parameter creator
 * 
 * @summary this method remove hotel page cache by hotel id
 * @param {number} hotelId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteAxiosParamCreator (hotelId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelRemoveHotelPageCacheHotelIdDelete', 'hotelId', hotelId)
    const localVarPath = `/api/hotel/RemoveHotelPageCache/{hotelId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {number} hotelMappingId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostAxiosParamCreator (hotelId: number, hotelMappingId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelToggleHotelMappingHotelIdHotelMappingIdPost', 'hotelId', hotelId)
    // verify required parameter 'hotelMappingId' is not null or undefined
    assertParamExists('apiHotelToggleHotelMappingHotelIdHotelMappingIdPost', 'hotelMappingId', hotelMappingId)
    const localVarPath = `/api/hotel/ToggleHotelMapping/{hotelId}/{hotelMappingId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)))
        .replace(`{${"hotelMappingId"}}`, encodeURIComponent(String(hotelMappingId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost - axios parameter creator
 * 
 * @param {number} hotelMappingId 
 * @param {boolean} saleEnable 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostAxiosParamCreator (hotelMappingId: number, saleEnable: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelMappingId' is not null or undefined
    assertParamExists('apiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost', 'hotelMappingId', hotelMappingId)
    // verify required parameter 'saleEnable' is not null or undefined
    assertParamExists('apiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost', 'saleEnable', saleEnable)
    const localVarPath = `/api/hotel/toggleHotelMappingSaleEnable/{hotelMappingId}/{saleEnable}`
        .replace(`{${"hotelMappingId"}}`, encodeURIComponent(String(hotelMappingId)))
        .replace(`{${"saleEnable"}}`, encodeURIComponent(String(saleEnable)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelImageFromProviderPost - axios parameter creator
 * 
 * @param {UpdateHotelImageRequest} [updateHotelImageRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelImageFromProviderPostAxiosParamCreator (updateHotelImageRequest?: UpdateHotelImageRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/updateHotelImageFromProvider`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateHotelImageRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelMappingHotelIdPost - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {UpdateHotelMappingRequest} [updateHotelMappingRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelMappingHotelIdPostAxiosParamCreator (hotelId: number, updateHotelMappingRequest?: UpdateHotelMappingRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelUpdateHotelMappingHotelIdPost', 'hotelId', hotelId)
    const localVarPath = `/api/hotel/UpdateHotelMapping/{hotelId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateHotelMappingRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelPost - axios parameter creator
 * 
 * @param {UpdateHotelRequest} [updateHotelRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelPostAxiosParamCreator (updateHotelRequest?: UpdateHotelRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/UpdateHotel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateHotelRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiHotelBackgroundHotelUpdatePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelBackgroundHotelUpdatePostRequest
 */
export interface HotelApiApiHotelBackgroundHotelUpdatePostRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelBackgroundHotelUpdatePost
     */
    readonly hotelId?: number
}

/**
 * Request parameters for apiHotelCityNameGetAllHotelRoomGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameGetAllHotelRoomGetRequest
 */
export interface HotelApiApiHotelCityNameGetAllHotelRoomGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly cityName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly hotelName?: string

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiHotelCityNameHotelNameCalendarGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameCalendarGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameCalendarGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameCalendarGet
     */
    readonly cityName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameCalendarGet
     */
    readonly hotelName: string
}

/**
 * Request parameters for apiHotelCityNameHotelNameGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly cityName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly hotelName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly childrenCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly roomCount?: number
}

/**
 * Request parameters for apiHotelCityNameHotelNameRecommendationsGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameRecommendationsGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameRecommendationsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRecommendationsGet
     */
    readonly cityName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRecommendationsGet
     */
    readonly hotelName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRecommendationsGet
     */
    readonly checkIn?: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRecommendationsGet
     */
    readonly checkOut?: string
}

/**
 * Request parameters for apiHotelCityNameHotelNameRoomsGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameRoomsGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameRoomsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly cityName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly hotelName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly childrenCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly roomCount?: number

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly xPlayerId?: string
}

/**
 * Request parameters for apiHotelCityNameHotelNameStaticGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameStaticGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameStaticGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameStaticGet
     */
    readonly cityName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameStaticGet
     */
    readonly hotelName: string
}

/**
 * Request parameters for apiHotelCityTagGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityTagGetRequest
 */
export interface HotelApiApiHotelCityTagGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityTagGet
     */
    readonly cityTag: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelCityTagGet
     */
    readonly xPlayerId?: string
}

/**
 * Request parameters for apiHotelCreateHotelMappingHotelIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCreateHotelMappingHotelIdPostRequest
 */
export interface HotelApiApiHotelCreateHotelMappingHotelIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelCreateHotelMappingHotelIdPost
     */
    readonly hotelId: number

    /**
     * 
     * @type {AddHotelMappingRequest}
     * @memberof HotelApiApiHotelCreateHotelMappingHotelIdPost
     */
    readonly addHotelMappingRequest?: AddHotelMappingRequest
}

/**
 * Request parameters for apiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest
 */
export interface HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete
     */
    readonly hotelId: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete
     */
    readonly hotelMappingId: number
}

/**
 * Request parameters for apiHotelGetHotelsWithRoomsCityIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest
 */
export interface HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly cityId: number

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly to?: string

    /**
     * 
     * @type {boolean}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly isOnlyDb?: boolean
}

/**
 * Request parameters for apiHotelHotelAutoCompleteListGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelAutoCompleteListGetRequest
 */
export interface HotelApiApiHotelHotelAutoCompleteListGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelAutoCompleteListGet
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for apiHotelHotelAvailabilityCityNameHotelNameGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest
 */
export interface HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly cityName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly hotelName: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly to?: string
}

/**
 * Request parameters for apiHotelHotelFullDetailsHotelIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelFullDetailsHotelIdGetRequest
 */
export interface HotelApiApiHotelHotelFullDetailsHotelIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelFullDetailsHotelIdGet
     */
    readonly hotelId: number
}

/**
 * Request parameters for apiHotelHotelIdAssignMappingMappingIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest
 */
export interface HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdAssignMappingMappingIdPost
     */
    readonly hotelId: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdAssignMappingMappingIdPost
     */
    readonly mappingId: number
}

/**
 * Request parameters for apiHotelHotelIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdGetRequest
 */
export interface HotelApiApiHotelHotelIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly hotelId: number

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly childrenCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly roomCount?: number
}

/**
 * Request parameters for apiHotelHotelIdStaticGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdStaticGetRequest
 */
export interface HotelApiApiHotelHotelIdStaticGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdStaticGet
     */
    readonly hotelId: number
}

/**
 * Request parameters for apiHotelHotelMappingListHotelIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelMappingListHotelIdGetRequest
 */
export interface HotelApiApiHotelHotelMappingListHotelIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelHotelMappingListHotelIdGet
     */
    readonly hotelId: number
}

/**
 * Request parameters for apiHotelHotelsAvailabilityByCityCityCodeGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest
 */
export interface HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet
     */
    readonly cityCode: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet
     */
    readonly to?: string
}

/**
 * Request parameters for apiHotelMessagePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelMessagePostRequest
 */
export interface HotelApiApiHotelMessagePostRequest {
    /**
     * 
     * @type {EditHotelMessageRequest}
     * @memberof HotelApiApiHotelMessagePost
     */
    readonly editHotelMessageRequest?: EditHotelMessageRequest
}

/**
 * Request parameters for apiHotelPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelPostRequest
 */
export interface HotelApiApiHotelPostRequest {
    /**
     * 
     * @type {CreateHotelRequest}
     * @memberof HotelApiApiHotelPost
     */
    readonly createHotelRequest?: CreateHotelRequest
}

/**
 * Request parameters for apiHotelRemoveHotelPageCacheHotelIdDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest
 */
export interface HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelRemoveHotelPageCacheHotelIdDelete
     */
    readonly hotelId: number
}

/**
 * Request parameters for apiHotelToggleHotelMappingHotelIdHotelMappingIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest
 */
export interface HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost
     */
    readonly hotelId: number

    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost
     */
    readonly hotelMappingId: number
}

/**
 * Request parameters for apiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest
 */
export interface HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost
     */
    readonly hotelMappingId: number

    /**
     * 
     * @type {boolean}
     * @memberof HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost
     */
    readonly saleEnable: boolean
}

/**
 * Request parameters for apiHotelUpdateHotelImageFromProviderPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelImageFromProviderPostRequest
 */
export interface HotelApiApiHotelUpdateHotelImageFromProviderPostRequest {
    /**
     * 
     * @type {UpdateHotelImageRequest}
     * @memberof HotelApiApiHotelUpdateHotelImageFromProviderPost
     */
    readonly updateHotelImageRequest?: UpdateHotelImageRequest
}

/**
 * Request parameters for apiHotelUpdateHotelMappingHotelIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest
 */
export interface HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelApiApiHotelUpdateHotelMappingHotelIdPost
     */
    readonly hotelId: number

    /**
     * 
     * @type {UpdateHotelMappingRequest}
     * @memberof HotelApiApiHotelUpdateHotelMappingHotelIdPost
     */
    readonly updateHotelMappingRequest?: UpdateHotelMappingRequest
}

/**
 * Request parameters for apiHotelUpdateHotelPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelPostRequest
 */
export interface HotelApiApiHotelUpdateHotelPostRequest {
    /**
     * 
     * @type {UpdateHotelRequest}
     * @memberof HotelApiApiHotelUpdateHotelPost
     */
    readonly updateHotelRequest?: UpdateHotelRequest
}

/**
* 
* @param {HotelApiApiHotelBackgroundHotelUpdatePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelBackgroundHotelUpdatePost(requestParameters: HotelApiApiHotelBackgroundHotelUpdatePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelBackgroundHotelUpdatePostAxiosParamCreator(requestParameters.hotelId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCityNameGetAllHotelRoomGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCityNameGetAllHotelRoomGet(requestParameters: HotelApiApiHotelCityNameGetAllHotelRoomGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCityNameGetAllHotelRoomGetAxiosParamCreator(requestParameters.cityName, requestParameters.hotelName, requestParameters.pageIndex, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<HotelShortDetailResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCityNameHotelNameCalendarGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCityNameHotelNameCalendarGet(requestParameters: HotelApiApiHotelCityNameHotelNameCalendarGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCityNameHotelNameCalendarGetAxiosParamCreator(requestParameters.cityName, requestParameters.hotelName, options, configuration);
    const request: () => AxiosPromise<Array<HotelCalendarDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCityNameHotelNameGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCityNameHotelNameGet(requestParameters: HotelApiApiHotelCityNameHotelNameGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCityNameHotelNameGetAxiosParamCreator(requestParameters.cityName, requestParameters.hotelName, requestParameters.from, requestParameters.to, requestParameters.adultCount, requestParameters.childrenCount, requestParameters.roomCount, options, configuration);
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCityNameHotelNameRecommendationsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCityNameHotelNameRecommendationsGet(requestParameters: HotelApiApiHotelCityNameHotelNameRecommendationsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCityNameHotelNameRecommendationsGetAxiosParamCreator(requestParameters.cityName, requestParameters.hotelName, requestParameters.checkIn, requestParameters.checkOut, options, configuration);
    const request: () => AxiosPromise<Array<HotelRecommendationDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCityNameHotelNameRoomsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCityNameHotelNameRoomsGet(requestParameters: HotelApiApiHotelCityNameHotelNameRoomsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCityNameHotelNameRoomsGetAxiosParamCreator(requestParameters.cityName, requestParameters.hotelName, requestParameters.from, requestParameters.to, requestParameters.adultCount, requestParameters.childrenCount, requestParameters.roomCount, requestParameters.xPlayerId, options, configuration);
    const request: () => AxiosPromise<RoomsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCityNameHotelNameStaticGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCityNameHotelNameStaticGet(requestParameters: HotelApiApiHotelCityNameHotelNameStaticGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCityNameHotelNameStaticGetAxiosParamCreator(requestParameters.cityName, requestParameters.hotelName, options, configuration);
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCityTagGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCityTagGet(requestParameters: HotelApiApiHotelCityTagGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCityTagGetAxiosParamCreator(requestParameters.cityTag, requestParameters.xPlayerId, options, configuration);
    const request: () => AxiosPromise<HotelSearchResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelCreateHotelMappingHotelIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelCreateHotelMappingHotelIdPost(requestParameters: HotelApiApiHotelCreateHotelMappingHotelIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelCreateHotelMappingHotelIdPostAxiosParamCreator(requestParameters.hotelId, requestParameters.addHotelMappingRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete(requestParameters: HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteAxiosParamCreator(requestParameters.hotelId, requestParameters.hotelMappingId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelGetAllHotelsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelGetAllHotelsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<HotelDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelGetHotelsWithRoomsCityIdGet(requestParameters: HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelGetHotelsWithRoomsCityIdGetAxiosParamCreator(requestParameters.cityId, requestParameters.from, requestParameters.to, requestParameters.isOnlyDb, options, configuration);
    const request: () => AxiosPromise<HotelCityFullDetailView> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Hotel AutoComplete List
* @param {HotelApiApiHotelHotelAutoCompleteListGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelAutoCompleteListGet(requestParameters: HotelApiApiHotelHotelAutoCompleteListGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelAutoCompleteListGetAxiosParamCreator(requestParameters.searchTerm, options, configuration);
    const request: () => AxiosPromise<AutoCompleteHotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet(requestParameters: HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetAxiosParamCreator(requestParameters.cityName, requestParameters.hotelName, requestParameters.from, requestParameters.to, options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Hotel Full Details
* @param {HotelApiApiHotelHotelFullDetailsHotelIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelFullDetailsHotelIdGet(requestParameters: HotelApiApiHotelHotelFullDetailsHotelIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelFullDetailsHotelIdGetAxiosParamCreator(requestParameters.hotelId, options, configuration);
    const request: () => AxiosPromise<HotelFullDetailsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelIdAssignMappingMappingIdPost(requestParameters: HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelIdAssignMappingMappingIdPostAxiosParamCreator(requestParameters.hotelId, requestParameters.mappingId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelHotelIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelIdGet(requestParameters: HotelApiApiHotelHotelIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelIdGetAxiosParamCreator(requestParameters.hotelId, requestParameters.from, requestParameters.to, requestParameters.adultCount, requestParameters.childrenCount, requestParameters.roomCount, options, configuration);
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelHotelIdStaticGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelIdStaticGet(requestParameters: HotelApiApiHotelHotelIdStaticGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelIdStaticGetAxiosParamCreator(requestParameters.hotelId, options, configuration);
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelHotelMappingListHotelIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelMappingListHotelIdGet(requestParameters: HotelApiApiHotelHotelMappingListHotelIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelMappingListHotelIdGetAxiosParamCreator(requestParameters.hotelId, options, configuration);
    const request: () => AxiosPromise<GetHotelMappingListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Hotel Type List
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelTypeListGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelTypeListGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<HotelTypeListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet(requestParameters: HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetAxiosParamCreator(requestParameters.cityCode, requestParameters.from, requestParameters.to, options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelHotelsWithMessageGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelsWithMessageGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<HotelFullDetailView>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary update message of hotel
* @param {HotelApiApiHotelMessagePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelMessagePost(requestParameters: HotelApiApiHotelMessagePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelMessagePostAxiosParamCreator(requestParameters.editHotelMessageRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelOrphanHotelMappingsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelOrphanHotelMappingsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<OrphanHotelMappingsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelPost(requestParameters: HotelApiApiHotelPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelPostAxiosParamCreator(requestParameters.createHotelRequest, options, configuration);
    const request: () => AxiosPromise<CreateHotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary this method remove hotel page cache by hotel id
* @param {HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelRemoveHotelPageCacheHotelIdDelete(requestParameters: HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteAxiosParamCreator(requestParameters.hotelId, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost(requestParameters: HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostAxiosParamCreator(requestParameters.hotelId, requestParameters.hotelMappingId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost(requestParameters: HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostAxiosParamCreator(requestParameters.hotelMappingId, requestParameters.saleEnable, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelUpdateHotelImageFromProviderPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelUpdateHotelImageFromProviderPost(requestParameters: HotelApiApiHotelUpdateHotelImageFromProviderPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelUpdateHotelImageFromProviderPostAxiosParamCreator(requestParameters.updateHotelImageRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelUpdateHotelMappingHotelIdPost(requestParameters: HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelUpdateHotelMappingHotelIdPostAxiosParamCreator(requestParameters.hotelId, requestParameters.updateHotelMappingRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelApiApiHotelUpdateHotelPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelApiApiHotelUpdateHotelPost(requestParameters: HotelApiApiHotelUpdateHotelPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelApiApiHotelUpdateHotelPostAxiosParamCreator(requestParameters.updateHotelRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
